// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2CCuc","select":"styles_select__1xb84"};